import countries from "./countries.json";
import subdivisions from "./subdivisions.json";
import getOptions from "./getOptions";

export { default as countries } from "./countries.json";
export { default as subdivisions } from "./subdivisions.json";

export const countryOptions = getOptions(countries);
export const subdivisionsOptions = getOptions(subdivisions);
